import React from "react";
import { useNavigate } from "react-router-dom";
import { Utensils } from "lucide-react";
import { T, tr } from "../lib/i18n";

// "Menu" pill for the brown bars — same look as the language selector.
export function MenuPill({ lang = "it" }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate("/")}
      className="inline-flex items-center gap-1.5 rounded-full border border-[#f7ebdf]/30 bg-[#f7ebdf]/10 backdrop-blur-sm px-3 py-1.5 text-sm font-medium text-[#f7ebdf] hover:bg-[#f7ebdf]/20 transition-colors shrink-0"
      data-testid="header-home-btn"
      aria-label={tr(T.menu, lang)}
    >
      <Utensils className="h-3.5 w-3.5 text-[#f7ebdf]/80" />
      <span className="text-xs font-semibold tracking-wide">{tr(T.menu, lang)}</span>
    </button>
  );
}
